module.exports = __webpack_public_path__ + "img/xiaofenggif.ce8ed405.gif";